module.exports = __webpack_public_path__ + "img/LamdeiniLearning-280.bd625c85.jpg";